<style scoped>
    .layout{
        width: 100%;
        height: 100%;
        background: #f5f7f9;
    }
    .Akso {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .layout-breadcrumb{
        padding: 10px 15px 0;
    }
    .layout-content{
        min-height: 500px;
        margin: 15px;
        overflow-y: scroll;
        background: #fff;
        border-radius: 4px;
    }
    .layout-content-main{
        padding: 10px;
    }
    .layout-menu-left{
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        background: #464c5b;
        transition: width .3s;
        overflow-y: scroll;
    }
    .layout-menu-left::-webkit-scrollbar {
      display: none;
    }
    .layout-menu-right{
        box-sizing: border-box;
        position: fixed;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
        z-index: 0;
        box-sizing: border-box;
        transition: padding .3s;
    }
    .layout-header{
        height: 60px;
        background: #fff;
        display: block;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }
    .layout-logo{
	    width: 60px;
	    height: 50px;
	    position: absolute;
	    top: 5px;
	    left: 20px;
    }
    .layout-logo .ivu-btn-text:focus {
      box-shadow: none;
    }
    .transroll {
      transform: none;
    }
    .layout-name{
      width: 300px;
      height: 30px;
      line-height: 30px;
      position: absolute;
      top: 15px;
      left: 90px;
      font-size: 24px;
    }
    .layout-avator{
      width: 240px;
      height: 36px;
      float: right;
      position: absolute;
      top: 12px;
      right: 20px;
    }
    .layout-avator .avator{
      width:36px;
      height: 36px;
      border-radius: 18px;
      margin-right: 20px;
    }
    .layout-avator .tooltip{
      margin-left:20px;
      margin-right: 20px;
    }
    .layout-avator .username{
      display: inline-block;
      width:80px;
      word-break: keep-all;
      vertical-align: middle;
      text-align: right;
      color: #2a86af;
    }
    .layout-logo-left{
        width: 80%;
        height: 60px;
        background: #464c5b;
        border-radius: 3px;
        margin: 10px auto;
    }
    .layout-logo-left img{
        height: 60px;
        width: 100%;
        background-color: rgba(255,255,255,.9);
        border-radius: 10px;
    }
    .business-logo {
        display: none;
    }
    .layout-ceiling-main a{
        color: #9ba7b5;
    }
    .layout-hide-text .layout-text{
        display: none;
    }
    .layout-hide-text .business-logo{
      display: block;
    }
    .layout-hide-text .transroll{
      transform: rotateZ(-90deg);
    }
    .ivu-col{
        transition: width .2s ease-in-out;
    }
</style>

<script>
	import axios from 'axios'
  import Cookies from 'js-cookie';
	export default {
		name: 'home',
		data () {
            return {
                shrink: false,
                spanLeft: 5,
                spanRight: 19,
                message: 3,
                activeName: 'homepage',
                openNames:[],
                menuTheme: 'dark',
                systemName: '阿科索商业系统',
                userName: ''
            }
        },
        computed: {
            iconSize () {
                return this.spanLeft === 5 ? 14 : 24;
            },
            menuList () {
                return this.$store.state.menuList;
            },
            avator () {
                var src = 'https://images.yitushijie.com/14668592332170089650'
                if (this.$store.state.avatorPath != '')  {
                  return this.$store.state.avatorPath;
                }
                return src
            },
            styleObj () {
                var height = document.body.clientHeight || document.documentElement.clientHeight
                return { 'height': (height-60-15*2)+'px' }
            }
        },
        methods: {
            toggleClick () {
                this.shrink = !this.shrink
                if (this.spanLeft === 5) {
                    this.spanLeft = 2;
                    this.spanRight = 22;
                } else {
                    this.spanLeft = 5;
                    this.spanRight = 19;
                }
            },
            handleChange (name) {
              this.$router.push({
                name: name
              });
            },
            handleUserDropdown (name) {
              if (name === 'ownSpace') {
                this.$Message.warning('暂未开放');
              } else if (name === 'loginout') {
                this.$store.commit('logout');
                this.$router.push({
                  name: 'login'
                });
              }
            }
        },
        mounted ()　{
		        this.$nextTick(function () {
              this.userName = Cookies.get('user');
            })
        }
	};
</script>

<template>
	<div class="layout" :class="{'layout-hide-text': shrink}">
        <div class="Akso">
            <div class="layout-menu-left" :style="{width: shrink?'100px':'230px'}">
                <div class="layout-logo-left">
                  <img src="../assets/logo.jpg" alt="" class="layout-text"/>
                  <img src="../assets/logo-min.jpg" alt="" class="business-logo"/>
                </div>
                <Menu :active-name="activeName" :open-names="openNames" width="auto" :theme="menuTheme" @on-select="handleChange">
                    <template v-for="item in menuList">
		                <MenuItem v-if="item.child.length <= 1" :key="item.child[0].name" :name="item.child[0].name">
		                   <Icon :type="item.icon" :size="iconSize" :key="'icon' + item.name"></Icon>
		                   <span class="layout-text" :key="'title' + item.name">{{item.child[0].title}}</span>
		                </MenuItem>
		                <Submenu v-if="item.child.length > 1" :key="item.name" :name="item.name">
		                    <template slot="title">
			                    <Icon :type="item.icon" :size="iconSize"></Icon>
			                    <span class="layout-text">{{item.title}}</span>
		                    </template>
			                <template v-for="child in item.child">
			                    <MenuItem :key="child.name" :name="child.name">
			                        <Icon :type="child.icon" :key="'icon' + child.name"></Icon>
			                        <span class="layout-text" :key="'title' + child.name">{{child.title}}</span>
			                    </MenuItem>
			                </template>
		                </Submenu>
                    </template>
                </Menu>
            </div>
            <div class="layout-menu-right" :style="{paddingLeft: shrink ? '100px':'230px'}">
                <div class="layout-header">
                    <div class="layout-logo">
	                    <Button type="text" @click="toggleClick" class="transroll">
                        <Icon type="navicon" size="32"></Icon>
	                    </Button>
                    </div>
                    <div class="layout-name">
                      {{systemName}}
                    </div>
                    <div class="layout-avator">
                      <Tooltip :content="message > 0 ? '有' + message + '条未读消息' : '无未读消息'" placement="top">
                          <Badge :count="message" dot>
                            <Icon type="ios-bell" size="22"></Icon>
                          </Badge>
                      </Tooltip>
                      <Tooltip :content="message > 0 ? '有' + message + '条未读消息' : '无未读消息'" placement="top" class="tooltip">
                          <Badge :count="message" dot>
                            <Icon type="chatbox-working" size="22"></Icon>
                          </Badge>
                      </Tooltip>
                      <Avatar :src="avator" class="avator"></Avatar>
		                  <Dropdown transfer trigger="click" @on-click="handleUserDropdown">
                        <a href="javascript:void(0)">
                          <span class="username oneline">{{userName}}</span>
                          <Icon type="arrow-down-b"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                          <DropdownItem name="ownSpace">个人信息</DropdownItem>
                          <DropdownItem name="loginout" divided>退出登录</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                </div>
                <div class="layout-content" :style="styleObj">
                  <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>







// WEBPACK FOOTER //
// src/views/Main.vue